import { Button } from "./Button/Button";

type Props = {
  icon: React.ReactNode;
  header: string | React.ReactNode;
  subHeader?: string | React.ReactNode;
  primaryActionLabel?: string;
  primaryActionOnClick?: () => void;
  primaryActionDisabled?: boolean;
  secondaryActionLabel?: string;
  secondaryActionOnClick?: () => void;
};

export default function EmptyState({
  icon,
  header,
  subHeader,
  primaryActionLabel,
  primaryActionOnClick,
  primaryActionDisabled,
  secondaryActionLabel,
  secondaryActionOnClick,
}: Props) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="relative flex h-12 w-12 items-center justify-center rounded-lg border border-border bg-white text-text-primary">
        <BackgroundCircle size={96} opacity={0.45} />
        <BackgroundCircle size={160} opacity={0.4} />
        <BackgroundCircle size={224} opacity={0.35} />
        <BackgroundCircle size={288} opacity={0.3} />
        <BackgroundCircle size={352} opacity={0.25} />
        <BackgroundCircle size={416} opacity={0.2} />
        <BackgroundCircle size={480} opacity={0} />
        {icon}
      </div>
      <div className="z-10">
        <h2 className="mt-4 max-w-96 text-center text-xl font-semibold">
          {header}
        </h2>
        {subHeader ? (
          <p className="mt-1 max-w-96 text-center text-text-secondary">
            {subHeader}
          </p>
        ) : null}
        {primaryActionLabel || secondaryActionLabel ? (
          <div className="mt-6 flex items-center justify-center gap-2">
            {primaryActionLabel && (
              <Button
                variant="default"
                disabled={primaryActionDisabled}
                onClick={primaryActionOnClick}
              >
                {primaryActionLabel}
              </Button>
            )}
            {secondaryActionLabel && (
              <Button variant="outline" onClick={secondaryActionOnClick}>
                {secondaryActionLabel}
              </Button>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}

function BackgroundCircle({
  size,
  opacity,
}: {
  size: number;
  opacity: number;
}) {
  return (
    <div
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-border"
      style={{
        width: size,
        height: size,
        opacity,
      }}
    ></div>
  );
}
